<template>
  <div>
    <list-search-box v-model="form" @submit="searchData" />
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="projectName" label="项目名称" align="left" min-width="150">
          <template v-slot="{row}">
            <el-button class="el-btn-text-left" type="text" @click="jumpProDetailPage(row)">
              {{ row.projectName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="contractNum" label="合同编号" align="left" min-width="130" />
        <el-table-column prop="distributorName" label="代理商名称" align="left" min-width="150" />
        <el-table-column prop="contractType" label="订单分类" align="left" min-width="80" />
        <el-table-column label="现销/赊销" align="left" min-width="80">
          <template v-slot="{row}">
            <span v-if="row.salesType === 1">现销</span>
            <span v-else-if="row.salesType === 2">赊销</span>
            <span v-else-if="row.salesType === 3">LC</span>
          </template>
        </el-table-column>
        <el-table-column label="分配比例" align="right" header-align="left" min-width="70">
          <template v-slot="{row}">
            <span>
              {{ row.assignRatio }}%
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="salesManName" label="外销" align="left" min-width="60" />
        <el-table-column prop="createTime" label="合同时间" align="left" min-width="90" />
        <el-table-column prop="date" label="合同附件" width="70" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="showFile(row)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
      <contract-file-dialog ref="fileDialog" />
    </div>
  </div>
</template>
<script type="es6">
import listSearchBox from './ListSearchBox';
import contractFileDialog from './ContractFileDialog';
import { selectContractInfoListForBusiness } from '@/API/international.js';

export default {
  data () {
    return {
      form: {
        projectName: '',
        contractNum: '',
        distributorName: '',
        salesManName: '',
        createBeginTime: '',
        createEndTime: ''
      },
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },

  components: {
    listSearchBox,
    contractFileDialog
  },

  mounted () {
    this.queryData();
  },

  methods: {
    queryData () {
      this.tableLoading = true;

      if (Object.keys(this.form).includes('startDistributionRatio')) {
        delete this.form.startDistributionRatio;
      }

      let params = {
        ...this.form,
        contractStatus: 2, // 已分配
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      selectContractInfoListForBusiness(params).then((res) => {
        let { status, data } = res.data;
        this.tableLoading = false;
        if (status === '200') {
          this.tableData = data.list;
          this.page.total = data.total;
          this.$emit('totalNumber', this.page.total);
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    searchData (data, cab) {
      this.page.currentPage = 1;
      this.queryData();
      cab(false);
    },

    // 改变每页条数 当前页回到第一页
    handerSizeChange () {
      this.page.currentPage = 1;
      this.queryData();
    },

    // 改变当前页
    handerCurrentChange () {
      this.queryData();
    },

    showFile ({ id }) {
      this.$refs.fileDialog.showFile(id);
    },

    // 项目详情
    jumpProDetailPage ({ contractNum, contractType, id, civilInternational }) {
      let type = 1;
      if (contractType === '国际业务下单' || contractType === '国际分销下单') {
        type = 3;
      } else {
        type = 1;
      }
      this.$router.push({
        name: 'businessDetails',
        params: { contractNum },
        query: { distributeFlag: true, type: type, id, isShowInternationalService: civilInternational || '0' }
      });
    }
  }

};
</script>
<style>
  .el-table .warning-row {
    color: red;
  }
  .el-table .highlight-row {
    color: #67C23A;
  }
</style>
